import React from 'react';
const Blank: React.FC = () => {
	return <div />;
};
export default Blank;
